module.exports = __webpack_public_path__ + "img/banner3.cafeaa79.png";